import { title, links, author } from "./config";
import { isArrayLike, isEmpty, kebabCase, lowerCase, sortedUniq } from "lodash";

// navbar mixins
export const navbar = {
  data: () => ({
    clipped: false,
    drawer: false,
    fixed: false,
    miniVariant: false,
    right: true,
    rightDrawer: true,
  }),
};

// footer mixins
export const footer = {
  data: () => ({
    fixed: false,
  }),
};

// global mixins
export const global = {
  data: () => ({
    darkMode: false,
    title,
    links,
    author: author || "no author",
  }),
  methods: {
    // lodash
    kebabCase: (c) => kebabCase(c),
    isEmpty: (c) => isEmpty(c),
    lowerCase: (c) => lowerCase(c),
    isArray: (arr) => isArrayLike(arr),
    sortedUniq: (arr) => sortedUniq(arr),

    // custom
    switchTheme() {
      this.$vuetify.theme.dark = this.darkMode = !this.$vuetify.theme.dark;
      this.updateLocalStorage("darkMode", this.darkMode);
    },
    updateLocalStorage(prop, val) {
      window.localStorage.setItem(prop, JSON.stringify(val));
      if (process.env.NODE_ENV === "development") {
        console.log(prop + ": " + val);
      }
    },
    getLocalStorage(prop) {
      return JSON.parse(window.localStorage.getItem(prop));
    },
  },
  mounted() {
    this.darkMode = this.getLocalStorage("darkMode") || false;
    this.$vuetify.theme.dark = this.darkMode;
  },
  computed: {
    showMobileMenu() {
      return ["xs"].includes(this.$vuetify.breakpoint.name);
    },
  },
};
